export enum ResultStatusType {
    PASS = "pass",
    FAIL = "fail",
    REVIEW = "review",
    ERROR = "error",
    PENDING = "pending"
}